import * as yup from 'yup';
import moment from 'moment';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const eventLocationValidation = yup.object().shape({
  date: yup.string().trim().required('Date is required'),
  from: yup.string().trim().required('Start time is required')
    .test('not-past-time', 'Start time cannot be in the past', function (value) {
      const { date } = this.parent;
      if (!value || !date) {
        return true;
      }
      const selectedDate = moment(date, 'YYYY-MM-DD', true);
      const today = moment().startOf('day');
      if (!selectedDate.isValid()) {
        return true;
      }
      if (selectedDate.isSame(today)) {
        const startTime = moment(`${date} ${value}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A'], true);
        if (!startTime.isValid()) {
          return true;
        }
        return startTime.isAfter(moment());
      }
      return true;
    }),
  to: yup.string().trim().required('End time is required')
    .test('end-after-start', 'End time must be after start time', function validateEndTime(value) {
      const { date, from } = this.parent;
      if (!value || !from || !date) {
        return true;
      }
      const start = moment(`${date} ${from}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A'], true);
      const end = moment(`${date} ${value}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A'], true);
      if (!start.isValid() || !end.isValid()) {
        return true;
      }
      return end.isAfter(start);
    })
    .test('not-past-time', 'End time cannot be in the past', function (value) {
      const { date } = this.parent;
      if (!value || !date) {
        return true;
      }
      const selectedDate = moment(date, 'YYYY-MM-DD', true);
      const today = moment().startOf('day');
      if (!selectedDate.isValid()) {
        return true;
      }
      if (selectedDate.isSame(today)) {
        const endTime = moment(`${date} ${value}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A'], true);
        if (!endTime.isValid()) {
          return true;
        }
        return endTime.isAfter(moment());
      }
      return true;
    }),
  address: yup.string().trim().required('Address is required').max(FIELD_LIMITS.ADDRESS.maxLength, `Address must be at most ${FIELD_LIMITS.ADDRESS.maxLength} characters`),
});

const eventLocationsValidation = yup.object().shape({
  locations: yup.array().of(eventLocationValidation)
    .min(1, 'At least one location is required')
    .max(7, 'You can add up to 7 locations'),
});

export const eventLocationsFieldConfigs = {
  address: FIELD_LIMITS.ADDRESS,
};

export default eventLocationsValidation;
